import { render } from "./JonHodges.vue?vue&type=template&id=3b95c367&ts=true"
import script from "./JonHodges.vue?vue&type=script&lang=ts"
export * from "./JonHodges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__